export const hubElementPlaceholderExtensionType =
	'com.atlassian.confluence.hub-element-placeholder';
export const hubElementPlaceholderExtensionKey = 'hub-element-placeholder';
